module.exports = __webpack_public_path__ + "static/img/wallpaper-mb3.d4ac225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wallpaper-mb3.jpg
// module id = iBCh
// module chunks = 1